import React from "react"
import Gimg from "gatsby-image"
import Section from "../templates/Section"

const renderBenefitCard = ({ header, body, image, link, id }) => (
  <div className="benefit-card" key={id}>
    <div className="benefit-card__img">
      {image.ext.toLowerCase() === ".svg" ? (
        <img src={image.publicURL} alt={header} />
      ) : (
        <Gimg fluid={image.childImageSharp.fluid} alt={header} />
      )}{" "}
    </div>
    <div className="benefit-card__content">
      <h3>{header}</h3>
      <p>{body}</p>
    </div>
  </div>
)

const renderBenefitCards = nodes =>
  nodes
    .map(c => c)
    .sort((a, b) => a.order - b.order)
    .map(c => renderBenefitCard(c))

const Benefits = props => {
  const nodes = props.graphql.nodes

  return (
    <Section header="Why TERSE">
      <div className="benefits">{renderBenefitCards(nodes)}</div>
    </Section>
  )
}

export default Benefits
